import React from 'react';
import Navbar from '@/components/navbar';
import Footer from '@/components/Footer';
import { Loader2 } from 'lucide-react';
import PricingHeader from '@/components/pricing/PricingHeader';
import PricingPlans from '@/components/pricing/PricingPlans';
import SocialProof from '@/components/pricing/SocialProof';
import FAQ from '@/components/pricing/FAQ';
import FinalCTA from '@/components/pricing/FinalCTA';
import { usePricingLogic } from '@/hooks/usePricingLogic';

const Pricing = () => {
  const {
    isLoadingUser,
    isProcessing,
    handleSelectPlan
  } = usePricingLogic();

  if (isLoadingUser) {
    return (
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <div className="flex-1 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      
      <main className="flex-1 relative overflow-hidden">
        {/* Background effects */}
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-b from-background to-background/80"></div>
          <div className="absolute top-0 left-0 right-0 h-[500px] bg-[radial-gradient(circle_at_center,rgba(29,185,84,0.1),transparent_40%)]"></div>
        </div>
        
        <div className="container relative z-10 px-4 py-24 mx-auto sm:px-6 lg:px-8">
          {/* Header */}
          <PricingHeader />
          
          {/* Pricing Cards */}
          <PricingPlans 
            isProcessing={isProcessing}
            onSelectPlan={handleSelectPlan}
          />
          
          {/* Social Proof */}
          <SocialProof />
          
          {/* FAQ Section */}
          <FAQ />
          
          {/* Final CTA */}
          <FinalCTA 
            isProcessing={isProcessing}
            onSelectPlan={handleSelectPlan}
          />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Pricing;
